/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="discounts.module.ts" />

module Meevo.Plugins.Discounts {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    class DiscountsController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        public objectState;

        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',

            'meevo.components.busy.BusyService',
            'meevo.plugins.discounts.discountsService',
            '$translate'
        ];

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

            protected busyService: Meevo.Components.Busy.IBusyService,
            protected discountsService: Meevo.Plugins.Discounts.IDiscountsService,
            protected $translate: angular.translate.ITranslateService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.objectState = ObjectStateEnum;
        }

        /**
         * Creates the context for editing/adding an item.
         * @return {}
         */
        createContext(): void {
            let vm = this;
            vm.busyService.start();
            vm.securityService.checkSection(vm.meevoSecurityKeys.REGISTER_DISCOUNTS_TAB_MAIN).then(() => {
                vm.busyService.stop();
                vm.context = new DiscountsContext(vm.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, vm.trackingService, vm.discountsService, vm.busyService);
                super.createContext();
                vm.context.activate(vm.selectedItemId, null, vm.asLocationId);

                vm.context.deactivate = () => {
                    vm.visualState = Model.MaintenanceFormVisualState.Search;
                };

                this.context.locationFieldList =
                    [
                        { field: 'ObjectState', label: this.$translate.instant("HEADER_STATUS"), checked: false },
                    ];
            });
        }

        preSearchCallback(criteria, rootCriteria) {
            if (!criteria.includeActive && !criteria.includeInactive && !criteria.includeDeleted) {
                criteria.includeActive = true;
            }
            criteria.isExpired = criteria.isExpiredLocal ? null : false;
            criteria.isEGift = false;
        }
    }


    angular.module("meevo.plugins.discounts")
        .controller("meevo.plugins.discounts.DiscountsController", DiscountsController);
}